import { render, staticRenderFns } from "./DropdownAttachment.vue?vue&type=template&id=b684b002&"
import script from "./DropdownAttachment.vue?vue&type=script&lang=js&"
export * from "./DropdownAttachment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports